<script setup>
import { ref } from 'vue'
import ElectricityUsageRecord from '../electricityUsageRecord/electricityUsageRecord.vue'
import Payment from '../payment/payment.vue'

const activeName = ref('electricityUsageRecord')
</script>

<template>
  <div class="electricity">
    <el-tabs v-model="activeName">
      <el-tab-pane label="实时电费" name="electricityUsageRecord"></el-tab-pane>
      <el-tab-pane label="用户交费记录" name="payment"> </el-tab-pane>
    </el-tabs>

    <Transition appear mode="out-in" name="el-fade-in-linear">
      <ElectricityUsageRecord
        v-if="activeName === 'electricityUsageRecord'"
      ></ElectricityUsageRecord>
      <Payment v-else-if="activeName === 'payment'"></Payment>
    </Transition>
  </div>
</template>

<style>
.electricity .el-tabs__header {
  padding-left: 36px;
  padding-right: 36px;
  height: 70px;
  display: flex;
  align-items: center;
  margin: 0;
}
</style>
